import LocalSeoPage from '@/pages/local/components/LocalSeoPage';
import { aracruzLubrificacao } from '@/mocks/localSeoData';

export default function LubrificacaoIndustrialAracruz() {
  return <LocalSeoPage data={aracruzLubrificacao} />;
}